'use client';

import { LogOutIcon } from 'lucide-react';
import { signOut } from 'next-auth/react';
import { useTranslations } from 'next-intl';

import type { JSX } from 'react';

import { DropdownMenuItem, HStack, Text } from '~/components';

export function SignOutItem(): JSX.Element {
  const t = useTranslations();

  const handleSignOut = () => {
    signOut();
  };

  return (
    <DropdownMenuItem onClick={handleSignOut} className='font-medium'>
      <HStack className='items-center'>
        <LogOutIcon className='size-5' color='#EF3054' />
        <Text>{t('commons.signOut')}</Text>
      </HStack>
    </DropdownMenuItem>
  );
}
